import { Quote } from '@britishcouncil/react-solas-ors3';

export const SessionStageChangedMsg = () => (
  <Quote title="" intent="warning">
    <p>
      At this moment the session stage is different than session stage of recorded registrations. It may be caused by
      delay between actual registering and attempting to pay by opening this payment page. What this implies is that the
      prices below are higher because of additional late stage fees applied.
    </p>
  </Quote>
);
